export const EMPTY_KYC_STATE = {
  pan: "",
  panFrontImage: "",
  panRearImage: "",

  authorisedSignatoryPan: "",
  authorisedSignatoryPanFrontImage: "",
  authorisedSignatoryPanRearImage: "",

  aadhar: "",
  aadharFrontImage: "",
  aadharRearImage: "",

  authorisedSignatoryAadhar: "",
  authorisedSignatoryAadharFrontImage: "",
  authorisedSignatoryAadharRearImage: "",

  passport: "",
  passportFrontImage: "",
  passportRearImage: "",

  authorisedSignatoryPassport: "",
  authorisedSignatoryPassportFrontImage: "",
  authorisedSignatoryPassportRearImage: "",

  residencyFrontImage: "",
  authorisedSignatoryResidencyFrontImage: "",

  certificateOfIncorporationFrontImage: "",

  gstCertificate: "",
  gstCertificateFrontImage: "",
};

export const REQUIRED_DOCUMENTS = {
  IN: {
    individual: ["pan", "aadhar", "gstCertificate"],
    company: [
      "pan",
      "authorisedSignatoryPan",
      "authorisedSignatoryAadhar",
      "certificateOfIncorporation",
      "gstCertificate",
    ],
  },
  INTL: {
    individual: ["passport", "residency", "gstCertificate"],
    company: [
      "authorisedSignatoryPassport",
      "authorisedSignatoryResidency",
      "certificateOfIncorporation",
      "gstCertificate",
    ],
  },
};

export const IMAGE_MAX_SIZE = 350;

export const HELP_CONTENT = {
  pan: {
    title: "PAN Card",
    documentTitle: "PAN Card",
    label: "PAN Number",
    subtitle: `Enter PAN Number linked to the added bank account and upload image of PAN Card`,
  },
  authorisedSignatoryPan: {
    title: "PAN Card",
    documentTitle: "PAN Card",
    label: "PAN Number",
    subtitle: `Enter your PAN Number and upload image of PAN Card`,
  },
  aadhar: {
    title: "Aadhaar Card",
    documentTitle: "Aadhaar Card",
    label: "Aadhaar Number",
    subtitle: `Enter your 12-digit Aadhaar Number and upload image of Aadhaar Card`,
  },
  authorisedSignatoryAadhar: {
    title: "Aadhaar Card",
    documentTitle: "Aadhaar Card",
    label: "Aadhaar Number",
    subtitle: `Enter your 12-digit Aadhaar Number and upload image of Aadhaar Card`,
  },
  passport: {
    title: "Passport Proof",
    documentTitle: "Passport",
    label: "Passport Number",
    subtitle: `Enter Passport Number and upload image of Passport`,
  },
  authorisedSignatoryPassport: {
    title: "Passport Proof",
    documentTitle: "Passport",
    label: "Passport Number",
    subtitle: `Enter Passport Number and upload image of Passport`,
  },
  residency: {
    title: "Residency Proof",
    documentTitle: "Residency Proof",
    subtitle: `Upload a valid residency proof (Any one of the following: Utility Bill, Bank Statement, Government-Issued ID, Lease/Rental Agreement)`,
  },
  authorisedSignatoryResidency: {
    title: "Residency Proof",
    documentTitle: "Residency Proof",
    subtitle: `Upload a valid residency proof (Any one of the following: Utility Bill, Bank Statement, Government-Issued ID, Lease/Rental Agreement)`,
  },
  certificateOfIncorporation: {
    title: "Certificate of Incorporation",
    documentTitle: "Certificate of Incorporation",
    subtitle: `Upload image of Certificate of Incorporation`,
  },
  gstCertificate: {
    title: "GST Certificate",
    documentTitle: "GST Certificate",
    label: "GST Number",
    subtitle: `Enter GST Number and upload image of GST Certificate`,
  },
};
